import * as types from './actionTypes';
import { MyCarsService } from '../services/index';
/**
 * My cars actions
 */
export const setMyCarsData = (payload: []) => ({
  type: types.SET_MY_CARS,
  payload,
});

export const setCurrentVehicle = (payload: {}) => ({
  type: types.SET_CURRENT_VEHICLE,
  payload,
});

export const setContactDetails = (payload: any) => ({
  type: types.SET_CONTACT_DETAILS,
  payload,
});

export const setVehicleDetailsComplete = (payload: any) => ({
  type: types.SET_LOAN_DETAILS_COMPLETE,
  payload,
});

export const setLoanDetailsComplete = (payload: any) => ({
  type: types.SET_LOAN_DETAILS_COMPLETE,
  payload,
});

export const setBankDetailsComplete = (payload: any) => ({
  type: types.SET_BANK_DETAILS_COMPLETE,
  payload,
});

export const setLoanDetailsInProgress = (payload: any) => ({
  type: types.SET_LOAN_DETAILS_INPROGRESS,
  payload,
});

export const setLoanDetails = (payload: any) => ({
  type: types.SET_LOAN_DETAILS,
  payload,
});

export const setBankDetails = (payload: any) => ({
  type: types.SET_BANK_DETAILS,
  payload,
});

export const setTransactionHistory = (payload: any) => ({
  type: types.SET_TRANSACTION_HISTORY_DETAILS,
  payload,
});

export const setOneTimePaymentDetails = (payload: any) => ({
  type: types.SET_ONE_TIME_PAYMENT_DETAILS,
  payload,
});

// My Cars - Vehicle Car Landing Page

export const fetchMyCarsRequestComplete = (payload: any) => ({
  type: types.SET_MY_CARS_REQUEST_COMPLETE,
  payload,
});

// My Cars - Vehicle Card Details

export const fetchMyCars = (env: string) => (dispatch: any) =>
  MyCarsService.fetchMyCars(env)
    .then((myCarsResponse) => {
      const myCarsAPIStatus = {
        isComplete: true,
        isError: false,
      };
      dispatch(fetchMyCarsRequestComplete({ myCarsAPIStatus, myCarsResponse }));
    })
    .catch((error) => {
      // eslint-disable-next-line
      const myCarsAPIStatus = {
        isComplete: true,
        isError: true,
        hasData: false,
      };
      dispatch(
        fetchMyCarsRequestComplete({ myCarsAPIStatus, myCarsResponse: [] })
      );
      console.error(error);
    });

// Fetch Personal Details
export const fetchContactDetails = (env: string) => async (dispatch: any) =>
  MyCarsService.fetchContactDetails(env)
    .then((contactDetails) => {
      dispatch(
        setContactDetails({ isContactDetailsComplete: true, contactDetails })
      );
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
    });

// Fetch Loan Details

export const fetchLoanDetails = (env: string, vehicleId: string) => async (
  dispatch: any
) => {
  dispatch(setLoanDetailsInProgress({ isLoanDetailsInprogress: true }));

  const loanDetails = await MyCarsService.fetchCarLoanDetails(env, vehicleId);

  dispatch(setLoanDetailsInProgress({ isLoanDetailsInprogress: false }));

  return dispatch(
    setLoanDetails({
      isLoanDetailsComplete: true,
      loanDetails,
      vehicleId,
    })
  );
};

// Fetch Bank Details

export const fetchBankDetails = (env: string, vehicleId: string) => async (
  dispatch: any
) => {
  const bankInfo = await MyCarsService.fetchCarBankInfo(env, vehicleId);

  dispatch(setLoanDetailsInProgress({ isLoanDetailsInprogress: false }));

  return dispatch(
    setBankDetails({
      isBankDetailsComplete: true,
      bankInfo,
      vehicleId,
    })
  );
};

// Fetch Transaction History

export const fetchTransactionHistory = (
  env: string,
  vehicleId: string
) => async (dispatch: any) => {
  const { transactionHistory } = await MyCarsService.fetchTransactionHistory(
    env,
    vehicleId
  );

  return dispatch(
    setTransactionHistory({
      isTransactionHistoryComplete: true,
      transactionHistory,
      vehicleId,
    })
  );
};

// Fetch and Update Bank Details -

/**
 * TODO: fetchLoanAndBankDetails May not be needed
 * */
export const fetchLoanAndBankDetails = (
  env: string,
  vehicleId: string,
  isMyCarsEmpty: boolean
) => async (dispatch: any) => {
  dispatch(setLoanDetailsInProgress({ isLoanDetailsInprogress: true }));

  if (isMyCarsEmpty) {
    dispatch(fetchMyCars(env));
  }

  const loanDetails = await MyCarsService.fetchCarLoanDetails(env, vehicleId);
  const bankInfo = await MyCarsService.fetchCarBankInfo(env, vehicleId);

  dispatch(setLoanDetailsInProgress({ isLoanDetailsInprogress: false }));

  return dispatch(
    setLoanDetails({
      isLoanDetailsComplete: true,
      isBankDetailsComplete: true,
      vehicleId,
      loanDetails,
      bankInfo,
    })
  );
};
